export const FILTER_ACTIONS = {
  SORT_BY: "SORT_BY",
  RATINGS: "RATINGS",
  CATEGORY: "CATEGORY",
  PRICE_RANGE: "PRICE_RANGE",
  CLEAR_FILTER: "CLEAR_FILTER",
};
